export class CuttingOrderStatus {
  id: number;
  name: string;
  action: OrderStatusAction;
  isDefault: boolean;
  enableEmailNotifyForClient: boolean;
  enableSMSNotifyForClient: boolean;
  enableEmailNotifyForUser: boolean;
  enableSMSNotifyForUser: boolean;
  color: string;

  constructor(status?: CuttingOrderStatus | any) {
    status = status || {};
    this.id = status.id || 0;
    this.name = status.name || '';
    this.isDefault = status.isDefault || false;
    this.action = status.action || OrderStatusAction.Create;
    this.enableEmailNotifyForClient = status.enableEmailNotifyForClient || true;
    this.enableSMSNotifyForClient = status.enableSMSNotifyForClient || false;
    this.enableEmailNotifyForUser = status.enableEmailNotifyForUser || true;
    this.enableSMSNotifyForUser = status.enableSMSNotifyForUser || false;
    this.color = status.color || '';
  }
}

export enum OrderStatusAction {
  Create,
  CuttingCompleted,
  Ordering,
  Verified,
  Confirm,
  Completed,
  Paid,
}
